import type * as React from 'react';

function SvgBurgerMenu(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M20 11H4C3.4478 11 3 11.4478 3 12C3 12.5522 3.4478 13 4 13H20C20.5522 13 21 12.5522 21 12C21 11.4478 20.5522 11 20 11Z"
        fill="currentColor"
      />
      <path
        d="M20 19H4C3.4478 19 3 19.4478 3 20C3 20.5522 3.4478 21 4 21H20C20.5522 21 21 20.5522 21 20C21 19.4478 20.5522 19 20 19Z"
        fill="currentColor"
      />
      <path
        d="M4 5H20C20.5522 5 21 4.5522 21 4C21 3.4478 20.5522 3 20 3H4C3.4478 3 3 3.4478 3 4C3 4.5522 3.4478 5 4 5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgBurgerMenu;
